module.exports = __webpack_public_path__ + "static/media/networking-icon.ca6826da.png";